import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { WMTS } from 'ol/source'
import { Tile as TileLayer} from 'ol/layer'

export function getBaselayer(projection) {
    let resolutions = [4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250,
        1000, 750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5]
    let extent =  [420000, 30000, 900000, 350000]

    var matrixIds = [];
    for (var i = 0; i < resolutions.length; i++) { matrixIds.push(i) }

    let tileGrid = new WMTSTileGrid({
        origin: [extent[0], extent[3]],
        resolutions: resolutions,
        matrixIds: matrixIds
    })
    let layer = 'ch.swisstopo.pixelkarte-grau'
    let opacity = 1
    let wmts = new WMTS({
        crossOrigin: 'anonymous',   // avoid CORS error
        url: 'https://wmts.geo.admin.ch/1.0.0/{Layer}/default/current/21781/{TileMatrix}/{TileRow}/{TileCol}.jpeg',
        tileGrid: tileGrid,
        projection: projection,
        layer: layer,
        requestEncoding: 'REST'
    })
    return new TileLayer({
        source: wmts,
        zIndex: 0,
        opacity: opacity,
        visible: true
    })
}